import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import FilterCheckboxList from '../../../components/Filters/Dispatch/FilterCheckboxList';

type Props = {

    zIndex: number;
    actingBodyId?: number;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    useNewStyle?: boolean;
};

function TagsDropdown({ value, setValue, zIndex, actingBodyId, useNewStyle }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getReportTags() {
        try {
            setIsLoading(true);
            const tags = await dispatchService.getDropDownReportTags(actingBodyId);
            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name,
                    color: tag.color
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getReportTags();
    }, [actingBodyId]);

    if (useNewStyle) {
        return <FilterCheckboxList items={items} value={value} setValue={setValue} renderBadge isLoading={isLoading} />;
    } else {
        return (
            <FilterDropdown
                label={translate('tags')}
                items={items}
                setValue={setValue}
                value={value}
                multiple={true}
                mode='BADGE'
                zIndex={zIndex}
            />
        );
    }
}

export default TagsDropdown;
